import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { chatBubbleIcon } from '@ld.consumer-portal/data-uri';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ld-chat-card',
  imports: [SvgIconComponent, TranslocoDirective],
  templateUrl: './chat-card.component.html',
  styleUrl: './chat-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatCardComponent {
  readonly heading = input<string>('chatCardHeading');
  readonly isMobile = input<boolean>(false);
  readonly isLoading = input<boolean>(false);
  readonly chatClick = output<void>();

  protected readonly chatIcon = chatBubbleIcon;

  protected onCardClick(): void {
    this.chatClick.emit();
  }
}
